export default __webpack_public_path__ + "static/media/mii.a8b5228a.png";